<script>
import { CSS_COLORS } from '@/components/css-constants.js'

export default {
  props: {
    // 活性状態
    disable: {
      type: Boolean,
      required: true,
    },
    // サイズ 'large' | 'default' | 'small'
    size: {
      type: String,
      default: 'default',
    },
    // 幅
    width: {
      type: String,
      required: false,
    },
      label: {
        type: String,
        required: false,
      },
    // アクティブ時のテキスト
    activeText: {
      type: String,
      required: false,
    },
    // 非アクティブ時のテキスト
    inactiveText: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

      primaryColor() {
          return CSS_COLORS.PRIMARY
      }
  },
  methods:{
    handleToggle(val) { this.$emit('change', val) },
  },
}
</script>

<template>
    <div class="toggle-switch">
        <span v-if="label">{{ label }}</span>
        <el-switch
          :active-color="primaryColor"
          v-model="modelValue"
          :disabled="disable"
          :size="size"
          :width="width"
          :active-text="activeText"
          :inactive-text="inactiveText"
          @change="handleToggle"
        />
    </div>
</template>

<style scoped>

.toggle-switch {
    display: inline-block;
}

</style>
